import { isInstallation } from 'compositions/OrderDetail/components/PartsAndServices/isInstallation';
import { GroupedTiresType } from 'compositions/Wizard/WizardContext';
import hash from 'object-hash';
import { Part } from 'types/UFOTypes';
import { INSTALLATION_TPMS, PQL_MOUNTING_WHEEL, TIRE_DEFAULT_QTY } from 'utils/constantValues';
import { getMspn } from 'utils/getMspn';
import type { SelectedMountingOptionType } from './MountingOptionsModal';
import { getDefaultOptions } from './defaultOptionsSelection';

const isComboUSed = (combo: SelectedMountingOptionType, selectedOptions: SelectedMountingOptionType[]) => {
  let isUsed = false;
  selectedOptions.forEach((option) => {
    if (
      hash({ installation: combo.installation, wheels: combo.wheels, tpms: combo.tpms }) ===
      hash({ installation: option.installation, wheels: option.wheels, tpms: option.tpms })
    )
      isUsed = true;
  });
  return isUsed;
};

const getValidCombination = (selectedOptions: SelectedMountingOptionType[], qty: number) => {
  const combos = getDefaultOptions(qty, false);
  const validCombo = combos.find((combo) => !isComboUSed(combo, selectedOptions)) || {
    installation: false,
    tpms: false,
    wheels: false,
    added: false,
    qty,
  };
  return validCombo;
};

export function getGroupedOptions(groupedTires: GroupedTiresType[]) {
  const tires: { mspn: string; options: SelectedMountingOptionType[] }[] = [];
  groupedTires.forEach((groupedTire) => {
    const options: SelectedMountingOptionType[] = [];
    groupedTire.tires.forEach((tire) => {
      const relatedTo = tire.hash;
      let installation = false;
      let wheels = false;
      let tpms = false;
      tire?.installations
        ?.filter((i) => !i.removed)
        .forEach((ins) => {
          if (isInstallation(ins.mspn)) installation = true;
          if (ins.mspn === PQL_MOUNTING_WHEEL) wheels = true;
          if (ins.mspn === INSTALLATION_TPMS) tpms = true;
        });
      options.push({
        installation,
        wheels,
        tpms,
        added: true,
        qty: tire.qty,

        related_to: relatedTo,
      });
    });
    while (options.length < 5) {
      options.push(getValidCombination(options, TIRE_DEFAULT_QTY));
    }
    tires.push({ mspn: groupedTire.tireMspn, options });
  });
  return tires;
}

export function getGroupedTiresFromOrder(parts: Part[]) {
  const groupedTires: GroupedTiresType[] = [];
  const noRemovedParts = parts.filter(
    (p) =>
      (p.removed === false || p.removed === undefined) &&
      (p.selected === true || p.selected === undefined) &&
      (p.deleted === false || p.deleted === undefined),
  );

  noRemovedParts
    .filter((part) => part.subtype === 'TIRE')
    .forEach((tire) => {
      const tireInstallations: Part[] = [];
      noRemovedParts.forEach((part) => {
        if (part.subtype !== 'TIRE' && part.related_to === tire.related_to) {
          tireInstallations.push(part);
        }
      });

      const existingTire = groupedTires.findIndex((groupedTire) => groupedTire.tireMspn === tire.mspn);
      if (existingTire === -1) {
        groupedTires.push({
          tireMspn: tire.mspn,
          tires: [
            {
              hash: tire.related_to || '',
              installations: tireInstallations.map((i) => ({
                mspn: getMspn(i) as string,
                quantity: i.quantity,

                related_to: i.related_to || '',
                removed: false,
                comment: i.comment,
              })),
              qty: tire.quantity,
            },
          ],
        });
      } else {
        const tireInstallationsArray = tireInstallations.map((i) => ({
          mspn: getMspn(i) as string,
          quantity: i.quantity,

          related_to: i.related_to || '',
          removed: false,
          comment: i.comment,
        }));
        groupedTires[existingTire].tires.push({
          hash: tire.related_to || '',
          installations: tireInstallationsArray,
          qty: tire.quantity,
        });
      }
    });
  return groupedTires;
}
